export default "__VITE_ASSET__FWEFKx56__"